import { getFullName } from '@/utils/name';
import { z } from 'zod';

export const platoUserDtoSchema = z
    .object({
        id: z.string(),
        firstName: z.string().nullable(),
        lastName: z.string().nullable(),
        email: z.string(),
    })
    .transform((data) => ({
        ...data,
        fullName: getFullName(data.firstName, data.lastName),
    }));

export type PlatoUserDTO = z.infer<typeof platoUserDtoSchema>;
